import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-asset-card',
  templateUrl: './asset-card.component.html',
  styleUrls: ['./asset-card.component.scss'],
})
export class AssetCardComponent implements OnInit {
  @Input() card: any;
  @Input() searchText: string = '';
  @Output() bookmarkEvent = new EventEmitter<any>();

  rating: any = [
    { id: 1, isRated: false },
    { id: 2, isRated: false },
    { id: 3, isRated: false },
    { id: 4, isRated: false },
    { id: 5, isRated: false }
  ];
  username : any;

  constructor(private _appService: AppService, private router: Router) { }

  ngOnInit(): void {
    this._appService.getUsername().subscribe(userdata => this.username = userdata);
    this.rating.forEach((element: any, index: number) => {

      if (index < Math.round(this.card.Average_Rating)) {
        element.isRated = true
      }
    });
  }

  onBookmarkClick(card: any) {
    card.User_BookMarked_Assets = !card.User_BookMarked_Assets;

    let isBookmarked;
    if (card.User_BookMarked_Assets) {
      isBookmarked = 1;
    } else {
      isBookmarked = 2;
    }
    this.bookmarkEvent.emit({ id: card.Asset_Id, isBookmarked })

  }

  viewAssetDetails(card: any) {
    this.router.navigate(["/assetdetails/", card.Asset_Id], { state: card })
    this._appService.upateAssetViewCount(this.username, card.Asset_Id).subscribe((res) => {
      if (res.message.toLowerCase() == "success") {
        card.view_count++;
      }
    });
  }

  onRating(card: any, rating: number) {
    card.Asset_rating = rating;
  }
}
